export default "__VITE_ASSET__DLwbbYUH__"